import { render, staticRenderFns } from "./ImportProductDetail.vue?vue&type=template&id=307ffed4&scoped=true&"
import script from "./ImportProductDetail.vue?vue&type=script&lang=js&"
export * from "./ImportProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ImportProductDetail.vue?vue&type=style&index=0&id=307ffed4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307ffed4",
  null
  
)

export default component.exports